import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import unchecked from "../images/unchecked_checkbox.png";
import checked from "../images/checkbox.png";
import logo from "../Pdfs/wipro-logo.png";
import top from "../images/topimage.PNG";
import centerimage from "../images/centerimg.PNG";
import footerimg1 from "../images/footerimg1.PNG";
import footerimg2 from "../images/footerimg2.PNG";
Font.register({ family: "Roboto", fontWeight: "bold" });
const styles = StyleSheet.create({
  Header: { margin: 2, fontSize: "11", fontWeight: "bold" },
  header2: { margin: 4, fontSize: "17", fontWeight: "bold" },
  image: {
    height: 12,
    width: 12,
  },
  centerimgleft: {
    height: 13,
    width: 13,
    marginLeft: -29,
    marginTop: -10,
  },
  centerimgright: {
    height: 13,
    width: 13,
    marginLeft: 530,
    marginTop: -10,
  },
  centerimg: {
    height: 13,
    width: 13,
    marginLeft: 250,
    marginTop: -30,
  },
  image1: {
    height: 19,
    width: 19,
  },
  logo: {
    height: 60,
    width: 100,
  },
  top: {
    height: 40,
    width: 600,
    marginLeft: -45,
    marginTop: -15,
  },
  footer1: {
    height: 40,
    width: 40,
    marginLeft: -45,
    marginTop: -17,
  },
  footer2: {
    height: 40,
    width: 40,
    marginTop: -40,
    marginLeft: 515,
  },
  splitRow1: {
    // width: "55%",
    // // borderStyle: "solid",
    // // borderColor: "#000",
    // // borderWidth: 1,
    // borderTopWidth: 0,
    // borderBottom:"1",
    // borderBottomWidth:1
    Top: 1,
    width: "51%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    marginRight: 20,
  },
  splitRow2: {
    // width: "45%",

    // // borderStyle: "solid",
    // // borderColor: "#000",
    // // borderWidth: 1,
    // // borderLeftWidth: 0,
    // // borderTopWidth: 0,
    // borderBottom:"1"
    width: "45%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    //marginLeft:10,

    borderTopWidth: 0,

    borderLeftWidth: 0,
    borderRightWidth: 0,
  },
  singleRow: {
    //     width: "100%",
    //     // borderStyle: "solid",
    //     // borderColor: "#000",
    //     //borderWidth: 1,
    //    // borderTopWidth: 0,
    //    borderBottom:"1"
    width: "100%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
  },
  tableCellSplitStyle: {
    margin: 5,
    fontSize: 11,
    paddingBottom: 10,
  },
  tableCellLabel: {
    margin: 5,
    fontSize: 11,
  },
  tableCellText: {
    fontSize: 9,
    marginLeft: 5,
    marginBottom: 1,
  },
});

const SoaDocument = (props) => {
 //console.log("clspprops",props)
  const createTableHeader = () => {
    return (
      <View style={tableRowStyle} fixed>
        <View style={firstTableColHeaderStyle}>
          <Text style={styles.Header}>*To Be Completed by Agent:</Text>
        </View>
      </View>
    );
  };

  return (
    <Document>
      <Page wrap={false} style={pageStyle} size="A4" orientation="portrait">
        <Image style={styles.top} alt="image" src={top} />
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Image
            style={styles.logo}
            alt="image"
            //src={props.pdfData.sex==="M"?checked:unchecked}
            src={logo}
          />

          <View
            style={{
              flexDirection: "column",
              display: "flex",
              marginRight: 140,
              fontSize: 20,
            }}
          >
            <Text style={{ textAlign: "right", marginTop: 25 }}>
              Scope of Sales Appointment
            </Text>
            <Text
              style={{
                textAlign: "right",
                //marginTop:-30
              }}
            >
              Confirmation Form
            </Text>
          </View>

          {/* <Text style={{ fontSize: 27}}>Virginia</Text>
          <Text style={{ fontSize: 27,marginLeft:89,marginTop:-30,fontWeight: "bold" }}>Premier</Text> */}

          {/* <Text style={{ fontSize: 8,marginLeft:182 }}>TM</Text> */}
        </View>
        <View>
          <Text style={{ fontSize: "11", marginTop: "10" }}>
            The Centers for Medicare & Medicaid Services requires sales agents
            to document the scope of a marketing appointment before any sales
            meeting to ensure understanding of what will be discussed between
            the sales agent and the Medicare beneficiary (or their authorized
            representative). All information provided on this form is
            confidential and should be completed by each person with Medicare or
            his/her authorized representative.
          </Text>
          <View>
            <Text
              style={{
                fontSize: 12,
                marginTop: "5",
                fontFamily: "Helvetica-Bold",
              }}
            >
              *Please INITIAL that you want the agent to discuss the following
              product:
            </Text>
          </View>
        </View>
        <View>
          <Text
            style={{ fontSize: 11, marginTop: 5, fontFamily: "Helvetica-Bold" }}
          >
            <Image
              style={styles.image}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={
                props?.pdfData?.MA1 === "YES" ||
                props?.pdfData?.productIds?.includes("MA1") ||
                props?.pdfData?.productName?.includes("MA1")
                  ? checked
                  : unchecked
              }
            />{" "}
            {"WIPRO PREMIER ADVANTAGE ELITE PLUS"}
            {"      "}
            <Image
              style={styles.image}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={
                props?.pdfData?.DSNP === "YES" ||
                props?.pdfData?.productIds?.includes("DSNP") ||
                props?.pdfData?.productName?.includes("DSNP")
                  ? checked
                  : unchecked
              }
            />{" "}
            {"WIPRO PREMIER ADVANTAGE ELITE"}
            {"          "}
          </Text>
          <View style={{ display: "flex", flexDirection: "row" }}>
            <Text
              style={{
                fontSize: 11,
                marginTop: 10,
                fontFamily: "Helvetica-Bold",
              }}
            >
              <Image
                style={styles.image}
                alt="image"
                //src={props.pdfData.sex==="M"?checked:unchecked}
                src={
                  props?.pdfData?.E005 === "YES" ||
                  props?.pdfData?.productIds?.includes("E005") ||
                  props?.pdfData?.productName?.includes("E005")
                    ? checked
                    : unchecked
                }
              />{" "}
              {"WIPRO ESSENCE ADVANTAGE (HMO)"}
              {"               "}
              <Image
                style={styles.image}
                alt="image"
                //src={props.pdfData.sex==="M"?checked:unchecked}
                src={
                  props?.pdfData?.E006 === "YES" ||
                  props?.pdfData?.productIds?.includes("E006") ||
                  props?.pdfData?.productName?.includes("E006")
                    ? checked
                    : unchecked
                }
              />{" "}
              {"WIPRO ESSENCE ADVANTAGE PLUS (HMO)"}
              {"    "}
            </Text>
          </View>
          <View style={{ display: "flex", flexDirection: "row" }}>
            <Text
              style={{
                fontSize: 11,
                marginTop: 10,
                fontFamily: "Helvetica-Bold",
              }}
            >
              <Image
                style={styles.image}
                alt="image"
                //src={props.pdfData.sex==="M"?checked:unchecked}
                src={
                  props?.pdfData?.PDP1 === "YES" ||
                  props?.pdfData?.productIds?.includes("PDP1") ||
                  props?.pdfData?.productName?.includes("PDP1")
                    ? checked
                    : unchecked
                }
              />{" "}
              {"WIPRO PREMIER ADVANTAGE ELITE BASIC"}
              {"    "}
            </Text>
          </View>
        </View>

        {/* <View style={box}>
          <Text style={{ fontSize: "11", fontWeight: "bold" }}>
            Please check (X) below the types of product(s) you would like the
            agent to discuss
          </Text>
          <Text style={{ fontSize: "11", marginTop: 10 }}>
            (Refer to page 2 for product type descriptions.)
          </Text>
          <Text style={{ fontSize: "13", marginTop: 10 }}>
            ______Great Plains Medicare Advantage (HMO I-SNP)
          </Text>
          <Text style={{ fontSize: "13", marginTop: 10 }}>
            ______Great Plains Medicare Advantage Gold (HMO I-SNP)
          </Text>
        </View> */}

        <View style={{ fontSize: 11, marginTop: "11", marginBottom: "7" }}>
          <Text style={{ fontFamily: "Helvetica-Bold" }}>
            By signing this form, you agree to a meeting with a sales agent to
            discuss the product type you{" "}
          </Text>
          <View style={{ display: "flex", flexDirection: "row" }}>
            <Text style={{ fontFamily: "Helvetica-Bold" }}>
              initialed above.
            </Text>
            <Text>
              {" "}
              Please note, the person who will discuss the product is employed
              by a Medicare plan.
            </Text>
          </View>
          <Text>
            They do not work directly for the Federal government. This
            individual may also be paid based on your enrollment in a plan.
          </Text>
          <View style={{ display: "flex", flexDirection: "row", marginTop: 5 }}>
            <Text>
              Signing this form{" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>does NOT</Text>{" "}
              obligate you to enroll in a plan, impact your current or future
              Medicare enrollment status, or automatically enroll you in the
              plan discussed.
            </Text>
          </View>
        </View>

        <View style={tableRowStyle} fixed>
          <View style={firstTableColHeaderStyle}>
            <Text style={styles.Header}>
              Beneficiary or Authorized Representative
            </Text>
          </View>
        </View>
        <View style={tableRowStyle}>
          <View style={styles.splitRow1}>
            <Text style={styles.tableCellLabel}>*Signature: </Text>
            <Text style={styles.tableCellText}>
              {props.dashboard === "prospect"
                ? props.pdfData?.beneRepSignature
                : props.pdfData.signature
                ? props.pdfData.signature
                : props.pdfData.repSignature}
            </Text>
          </View>

          <View style={styles.splitRow2}>
            <Text style={styles.tableCellLabel}>*Signature Date: </Text>
            <Text style={styles.tableCellText}>
              {props.dashboard === "prospect"
                ? props.pdfData?.beneRepSignDate
                : props.pdfData.date
                ? props.pdfData.date
                : props.pdfData.repDate}
            </Text>
          </View>
        </View>
        <View style={tableRowStyle} fixed>
          {/* <View style={styles.singleRow}> */}
          <Text style={styles.tableCellLabel}>
            If you are the authorized representative, please sign above and
            print below.
          </Text>
          {/* <Text style={styles.tableCellText}>{props.pdfData.signature?props.pdfData.signature:props.pdfData.repSignature?props.pdfData.repSignature:props.pdfData.beneRepSignature}</Text> */}
          {/* </View> */}
        </View>

        <View style={tableRowStyle}>
          <View style={styles.splitRow1}>
            <Text style={styles.tableCellLabel}>Representative’s Name:</Text>
            <Text style={styles.tableCellText}>
              {props.pdfData.name ? props.pdfData.name : props.pdfData.repName}
            </Text>
          </View>

          <View style={styles.splitRow2}>
            <Text style={styles.tableCellLabel}>
              Relationship to Beneficiary:{" "}
            </Text>
            <Text style={styles.tableCellText}>
              {props.pdfData?.relationship === "SELF" ||
              props.pdfData?.repRelationShip === "SELF" ||
              props.pdfData?.relationshipToBene === "SELF"
                ? props.pdfData?.repRelationShip
                : props.component === "fullrelation"
                ? props.authorizedrelations.filter(
                    (data) =>
                      data.value ==
                      (props.pdfData.repRelationShip
                        ? props.pdfData.repRelationShip
                        : props.pdfData.relationship)
                  )[0]?.label
                : props.dashboard === "prospect"
                ? props.authorizedrelations.filter(
                    (data) =>
                      data.value ==
                      (props.pdfData?.relationshipToBene
                        ? props.pdfData?.relationshipToBene
                        : "")
                  )[0]?.label
                : ""}
            </Text>
          </View>
        </View>
        <Image
          style={styles.centerimgleft}
          alt="image"
          //src={props.pdfData.sex==="M"?checked:unchecked}
          src={centerimage}
        />
        <Image
          style={styles.centerimgright}
          alt="image"
          //src={props.pdfData.sex==="M"?checked:unchecked}
          src={centerimage}
        />
        <View style={tableStyle}>
          {createTableHeader()}
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>*Agent Name :</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData.agentName}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>*Agent Phone :</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData?.agentPh
                  ? props.pdfData.agentPh?.length <= 10
                    ? "(" +
                      props.pdfData.agentPh.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData.agentPh.slice(3, 6) +
                      "-" +
                      props.pdfData.agentPh.slice(6, 11)
                    : props.pdfData.agentPh
                  : props.pdfData?.agentPhone?.length <= 10
                  ? "(" +
                    props.pdfData.agentPhone.slice(0, 3) +
                    ")" +
                    " " +
                    props.pdfData.agentPhone.slice(3, 6) +
                    "-" +
                    props.pdfData.agentPhone.slice(6, 11)
                  : props.pdfData?.agentPhone}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>*Beneficiary Name :</Text>
              <Text style={styles.tableCellText}>
                {props.dashboard === "prospect"
                  ? props.pdfData?.beneName
                  : props.pdfData.benName
                  ? props.pdfData.benName
                  : props.pdfData.beneficiaryName}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>
                *Beneficiary Phone (Optional) :
              </Text>
              <Text style={styles.tableCellText}>
                {props.pdfData?.benePhone
                  ? props.pdfData?.benePhone?.length <= 10
                    ? "(" +
                      props.pdfData?.benePhone.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData?.benePhone.slice(3, 6) +
                      "-" +
                      props.pdfData?.benePhone.slice(6, 11)
                    : props.pdfData?.benePhone
                  : props.pdfData.benPh
                  ? props.pdfData.benPh.length <= 10
                    ? "(" +
                      props.pdfData.benPh.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData?.benPh.slice(3, 6) +
                      "-" +
                      props.pdfData?.benPh.slice(6, 11)
                    : props.pdfData?.benPh
                  : props.pdfData?.beneficiaryPhone
                  ? props.pdfData?.beneficiaryPhone?.length <= 10
                    ? "(" +
                      props.pdfData?.beneficiaryPhone.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData?.beneficiaryPhone.slice(3, 6) +
                      "-" +
                      props.pdfData?.beneficiaryPhone.slice(6, 11)
                    : props.pdfData?.beneficiaryPhone
                  : ""}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellLabel}>*Beneficiary Address:</Text>
              <Text style={styles.tableCellText}>
                {props.dashboard === "prospect"
                  ? props.pdfData.beneAddress
                  : props.pdfData.benAdd
                  ? props.pdfData.benAdd
                  : props.pdfData.beneficiaryAddress}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View
            // style={styles.singleRow}
            >
              <Text style={styles.tableCellSplitStyle}>
                Initial method of contact (check one):
              </Text>
              <Text style={{ fontSize: 11, marginTop: -13, marginLeft: 20 }}>
                {"  "}
                <Image
                  style={styles.image}
                  alt="image"
                  //src={props.pdfData.sex==="M"?checked:unchecked}
                  src={
                    props.pdfData?.contact?.trim()?.toUpperCase()?.includes("SALE") ||
                    //=== "Sales event" ||
                    props.pdfData.initialMethodOfContact?.trim()?.toUpperCase()?.includes("SALE") 
                    // === "Sales" ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "Sales event" ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "SALES EVENT"

                      ? checked
                      : unchecked
                  }
                />{" "}
                Sales event {"    "}
                <Image
                  style={styles.image}
                  alt="image"
                  //src={props.pdfData.sex==="F"?checked:unchecked}
                  src={
                    props.pdfData.contact?.trim()?.toUpperCase()?.includes("WALK") ||
                    props.pdfData.initialMethodOfContact?.trim()?.toUpperCase()?.includes("WALK")
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "Walk-in" ||
                    // props.pdfData.initialMethodOfContact?.trim() === "WALK-IN"
                      ? checked
                      : unchecked
                  }
                />{" "}
                Walk-in {"    "}
                <Image
                  style={styles.image}
                  alt="image"
                  //src={props.pdfData.sex==="F"?checked:unchecked}
                  src={
                    props.pdfData.contact?.trim()?.toUpperCase()?.includes("INBOU") ||
                    props.pdfData.initialMethodOfContact?.trim()?.toUpperCase()?.includes("INBOU") 
                    // ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "Inbound" ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "INBOUND" ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "INBOUND CALL"
                      ? checked
                      : unchecked
                  }
                />{" "}
                Inbound call {"    "}
                <Image
                  style={styles.image}
                  alt="image"
                  //src={props.pdfData.sex==="F"?checked:unchecked}
                  src={
                    props.pdfData?.contact?.trim()?.toUpperCase()?.includes("OUTBOU") ||
                    props.pdfData.initialMethodOfContact?.trim()?.toUpperCase()?.includes("OUTBOU")
                    // ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "Outbound Call" ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "OUTBOUND CALL"
                      ? checked
                      : unchecked
                  }
                />{" "}
                Outbound Call {"    "}
                <Image
                  style={styles.image}
                  alt="image"
                  //src={props.pdfData.sex==="F"?checked:unchecked}
                  src={
                    props.pdfData.contact?.trim()?.toUpperCase()?.includes("PERMI") 
                    ||
                    props.pdfData.initialMethodOfContact?.trim()?.toUpperCase()?.includes("PERMI")
                    //  ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "Permission to call card" ||
                    // props.pdfData.initialMethodOfContact?.trim() ===
                    //   "PERMISSION TO CALL CARD"
                      ? checked
                      : unchecked
                  }
                />{" "}
                Permission to call card {"    "}
              </Text>

              {/* <View
              style={{
                width: "100%",
                borderStyle: "solid",
                borderColor: "#000",
                borderBottomColor: "#000",
                borderWidth: 1,
                padding: 4,
                paddingTop:2,
                borderLeft:0,
                borderTop:0,
                borderRight:0,
                borderBottom:0
              }}
            > */}
              <View style={{ display: "flex", flexDirection: "row" }}>
                <Text style={{ fontSize: 11, marginTop: 10, marginLeft: 20 }}>
                  <Image
                    style={styles.image}
                    alt="image"
                    //src={props.pdfData.sex==="F"?checked:unchecked}
                    src={
                      (props.pdfData.contact?.slice(0, 6) ||
                        props.pdfData.initialMethodOfContact?.trim()) ===
                      "Other"
                        ? checked
                        : unchecked
                    }
                  />{" "}
                  Other (specify){"    "}
                </Text>
                <Text style={{ fontSize: 9,marginTop:10 }}>
                {props.pdfData?.salesChannelOth
                  ? props.pdfData.salesChannelOth
                  : ""}
              </Text>
              </View>
              <Text style={{ marginLeft: 113, marginTop: -21 }}>
                ________________________________________
              </Text>
              {/* </View> */}
            </View>
          </View>

          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>*Agent Signature</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData.agentSign
                  ? props.pdfData.agentSign
                  : props.pdfData.agentSignutre}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>
                *Date Appointment Completed:
              </Text>
              <Text style={styles.tableCellText}>
                {props.dashboard == "prospect"
                  ? props.pdfData?.appointmentDateComp
                  : props.pdfData.dac
                  ? props.pdfData.dac
                  : props.pdfData.dateApntmntCmpltd}
              </Text>
            </View>
          </View>

          {/* {createTableRow()}
          {createTableRow()}
          {createTableRow()}
          {createTableRow()} */}
        </View>
        <View style={{ fontSize: "11", marginTop: "5" }}>
          <Text>
            Note:Scope of Appointment documentation is subject to CMS record
            retention requirements
          </Text>
        </View>

        <View style={tableRowStyle} fixed>
          <View style={firstTableColHeaderStyle}>
            <Text style={styles.Header}>Plan Use Only</Text>
          </View>
        </View>
        <View style={tableRowStyle}>
          <View style={styles.singleRow}>
            <Text style={styles.tableCellSplitStyle}>
              Agent, if the form was signed by the beneficiary at time of
              appointment, provide explanation why SOA was not documented prior
              to meeting:
            </Text>
          </View>
        </View>
        <View style={tableRowStyle}>
          <View style={styles.singleRow}>
            <Text style={styles.tableCellSplitStyle}>
              If Telephonic Scope of Appointment was obtained, please indicate
              date and time:
            </Text>
          </View>
        </View>

        <Text style={{ fontSize: 11, marginTop: 3 }}>
          *this information is required
        </Text>
        <Text style={{ fontSize: 10, marginTop: -10, marginLeft: 350 }}>
          H1234_0123_SOAWP_500000_C
        </Text>
        <View>
          <Text
            style={{
              fontSize: 5,
              textAlign: "left",
              marginTop: 15,
              marginLeft: -1,
            }}
          >
            H1234_0123_SOAWP_500000_C .indd 1
          </Text>
          <Text
            style={{
              fontSize: 5,
              textAlign: "right",
              marginTop: -10,
              marginRight: 10,
            }}
          >
            6/24/2021 10:16:53 AM
          </Text>
        </View>
        <Image
          style={styles.footer1}
          alt="image"
          //src={props.pdfData.sex==="M"?checked:unchecked}
          src={footerimg1}
        />
        <Image
          style={styles.footer2}
          alt="image"
          //src={props.pdfData.sex==="M"?checked:unchecked}
          src={footerimg2}
        />
        <Image
          style={styles.centerimg}
          alt="image"
          //src={props.pdfData.sex==="M"?checked:unchecked}
          src={centerimage}
        />
      </Page>
      <Page wrap={false} style={pageStyle} size="A4" orientation="portrait">
        <Image
          style={styles.top}
          alt="image"
          //src={props.pdfData.sex==="M"?checked:unchecked}
          src={top}
        />
        {/* <View style={tableStyle}>
          <View style={tableRowStyle} fixed>
            <View style={firstTableColHeaderStyle}>
              <Text style={styles.header2}>
                Great Plains Medicare Advantage
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellSplitStyle}>
                Medicare Health Maintenance Organization (HMO) is a Medicare
                Advantage plan that provides all Original Medicare Part A and
                Part B health coverage and sometimes covers Part D prescription
                drug coverage. In most HMOs you can only get your care from
                doctors or hospitals in the plan’s network (except in
                emergencies).
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellSplitStyle}>
                Institutional Special Needs Plans (I-SNP) are Medicare Advantage
                plans with benefit packages for people with special health care
                needs. The I-SNP is designed for people who, for 90 days or
                longer, have had or are expected to need the level of services
                provided in an institutional level of care.
              </Text>
            </View>
          </View>
        </View> */}
        <View style={{ fontSize: 12, marginTop: 20 }}>
          <Text>Medicare Advantage Plans (Part C)</Text>
          <Text style={{ marginTop: 13 }}>
            The type of Medicare Advantage Plan Wipro Premier offers include:
          </Text>
          <Text style={{ marginTop: 13, fontFamily: "Helvetica-Bold" }}>
            Medicare Advantage Special Needs Plan (D-SNP)
          </Text>
          <Text style={{ marginTop: 1 }}>
            A Medicare Advantage Plan that provides all Original Medicare Part A
            and B health coverage and covers Part D prescription drug coverage
            for all members with Special Needs. Examples of groups served
            include people who have both Medicare and Medicaid, reside in
            nursing homes and have certain chronic medical conditions. In most
            HMOs, you can only get your care from doctors or hospitals in the
            plan’s network (except in emergencies).
          </Text>
          <Text style={{ marginTop: 12 }}>
            By signing this form you are agreeing to a sales meeting with a
            sales agent to discuss the specific types of products you initialed
            above. The person that will be discussing plan options with you is
            either employed or contracted by a Medicare health plan or
            prescription drug plan that is not the Federal government, and they
            may be compensated based on your enrollment in a plan. Signing this
            form does NOT affect your current enrollment, nor will it enroll you
            in a Medicare Advantage Plan, Prescription Drug Plan, or other
            Medicare plan.
            <View></View>
          </Text>
          <Text style={{ marginTop: 140, marginLeft: -30 }}>
            <Image
              style={styles.centerimgleft}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={centerimage}
            />
          </Text>
          <Text style={{ marginLeft: 533, marginTop: -15 }}>
            <Image
              style={styles.centerimgright}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={centerimage}
            />
          </Text>
          <Text style={{ marginTop: 243 }}>
            Wipro Premier is an HMO D-SNP organization with a Medicare contract.
            Enrollment in any
          </Text>
          <Text>Wipro Premier plan depends on contract renewal</Text>
        </View>

        <View>
          <Text
            style={{
              fontSize: 5,
              textAlign: "left",
              marginLeft: 5,
              marginTop: 105,
            }}
          >
            H1234_0123_SOAWP_500000_C .indd 1
          </Text>
          <Text
            style={{
              fontSize: 5,
              textAlign: "right",
              marginRight: 15,
              marginTop: -10,
            }}
          >
            6/24/2021 10:16:53 AM
          </Text>

          <View>
            <Image
              style={styles.footer1}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={footerimg1}
            />
            <Image
              style={styles.footer2}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={footerimg2}
            />
            <Text></Text>
            <Image
              style={styles.centerimg}
              alt="image"
              //src={props.pdfData.sex==="M"?checked:unchecked}
              src={centerimage}
            />
          </View>
        </View>
      </Page>
    </Document>
  );
};

const box = {
  marginLeft: 18,
  width: "90%",
  display: "table",
  backgroundColor: "#bdbdbd",
  top: "10",
  paddingTop: "15",
  paddingBottom: "15",
  textAlign: "center",
};
const pageStyle = {
  paddingTop: 16,
  paddingHorizontal: 40,
  paddingBottom: 56,
};

const tableStyle = {
  display: "table",
  width: "auto",
};

const tableRowStyle = {
  flexDirection: "row",
};

const firstTableColHeaderStyle = {
  width: "100%",
  //borderStyle: "solid",
  //borderColor: "#000",
  //borderBottomColor: "#000",
  //borderWidth: 1,
  marginTop: 4,
  backgroundColor: "#484848",
  color: "#FFFFFF",
};

const tableColHeaderStyle = {
  width: "20%",
  borderStyle: "solid",
  borderColor: "#000",
  borderBottomColor: "#000",
  borderWidth: 1,
  borderLeftWidth: 0,
  backgroundColor: "#bdbdbd",
};

const firstTableColStyle = {
  width: "20%",
  borderStyle: "solid",
  borderColor: "#000",
  borderWidth: 1,
  borderTopWidth: 0,
};

const tableColStyle = {
  width: "20%",
  borderStyle: "solid",
  borderColor: "#000",
  borderWidth: 1,
  borderLeftWidth: 0,
  borderTopWidth: 0,
};

const tableCellHeaderStyle = {
  textAlign: "center",
  margin: 4,
  fontSize: "12",
  fontWeight: "bold",
};

const tableCellStyle = {
  textAlign: "center",
  margin: 5,
  fontSize: 10,
};
const mapStateToProps = (state) => {
  return {
    pdfData: state.webApp.soa,
    selectedPlanName: state.login.selectedPlanName,
  };
};

const mapDispatchToProps = {};

//export default connect(mapStateToProps, mapDispatchToProps)(TableDocument);
export default SoaDocument;
